export default {
  GET_ALL: `#graphql
  query getImages($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getImages(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        image,
        dir
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_BY_IMAGE: `#graphql
  query getByImage($image: String!) {
    getByImage(image: $image)
    { 
      image,
      dir
    }            
  }`,

  GET_HISTORY: `#graphql
  query getImagesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getImagesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        image,
        folder,
        subfolder,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`,

  UPLOAD: `#graphql
  mutation uploadImage($image: Upload!, $folder: String!, $subfolder: String) {
    uploadImage(image: $image, folder: $folder, subfolder:$subfolder)
    {
      image,
      folder,
      subfolder
    }
  }`,

  UPLOAD_IMAGE_PRODUCT: `#graphql
  mutation uploadImageProduct($image: Upload!, $folder: String!, $subfolder: String!, $brand: String!, $size: Int!, $token: String!) {
    uploadImageProduct(image: $image, folder: $folder, subfolder: $subfolder, brand: $brand, size: $size, token: $token)
  }`,

  UPLOAD_IMAGE_MEASURE: `#graphql
  mutation uploadImageMeasure($image: Upload!, $url: String!, $size: Int!, $token: String!) {
    uploadImageMeasure(image: $image, url: $url, size: $size, token: $token)
  }`,

  UPLOAD_IMAGE_DELIVERY: `#graphql
  mutation uploadImageDelivery($image: Upload!, $delivery: String!, $token: String!) {
    uploadImageDelivery(image: $image, delivery: $delivery, token: $token)
  }`,

  UPLOAD_IMAGE_REFUND: `#graphql
  mutation uploadImageRefund($image: Upload!, $refund: String!, $token: String!) {
    uploadImageRefund(image: $image, refund: $refund, token: $token)
  }`,

  DELETE: `#graphql
  mutation DeleteImage($image: String!) {
    deleteImage(image:$image)
    {
      image
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/image.js